export default "__VITE_ASSET__c7687c1b__"